import Swiper from 'swiper/bundle';

export default function carousel()
{
    // eslint-disable-next-line no-new
    new Swiper('.swiper', {
        loop: true,
        speed: 800,
        slidesPerView: 1,
        // initialSlide: 1,
        centeredSlides: true,
        parallax: true,
        grabCursor: true,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 80,
            },
        },
    });
}
